<template>
	<layout-gestao>
		<div class="row">
			<div class="col-sm-12">
				<form
					autocomplete="off"
					method="post"
					:disabled="isLoading"
					data-vv-scope="form"
					@submit.prevent="saveItem"
					>
					<div class="row mb-3">
						<div class="col-sm-auto">
							<h1 class="content-title">
								{{ titleItem }}
							</h1>
						</div>
					</div>
					<nav>
						<div
							id="nav-tab"
							class="nav nav-tabs nav-fill mb-3 sky-blue"
							role="tablist">
							<a
								class="nav-item nav-link active"
								data-toggle="tab"
								:href="'#'+tabs[0]['code']"
								role="tab"
								aria-selected="true"
								@click.prevent="localActive=tabs[0]">
								{{ tabs[0]['name'] }}
							</a>
							<a
								id="nav-parishes-tab"
								class="nav-item nav-link"
								data-toggle="tab"
								:href="'#'+tabs[1]['code']"
								role="tab"
								aria-controls="nav-parishes"
								aria-selected="false"
								@click.prevent="localActive=tabs[1]">
								{{ tabs[1]['name'] }}
							</a>
							<a
								id="nav-users-tab"
								class="nav-item nav-link"
								data-toggle="tab"
								:href="'#'+tabs[2]['code']"
								role="tab"
								aria-controls="nav-users"
								aria-selected="false"
								@click.prevent="localActive=tabs[2]">
								{{ tabs[2]['name'] }}
							</a>
						</div>
					</nav>

					<div id="nav-tabContent" class="tab-content">
						<div
							:id="`nav-${tabs[0]['code']}`"
							class="tab-pane fade"
							:class="{'show active': localActive==tabs[0]}"
							role="tabpanel"
							:aria-labelledby="`nav-${tabs[0]['code']}-tab`">
							<unity-general
								v-model="form"
								vScope="general"
								:onoff="lists.onoff"
								:propPageID="pageID"
							/>
						</div>

						<div
							:id="`nav-${tabs[1]['code']}`"
							class="tab-pane fade"
							:class="{'show active': localActive==tabs[1]}"
							role="tabpanel"
							:aria-labelledby="`nav-${tabs[1]['code']}-tab`">
							<unity-parishes
								v-model="form.parishes"
								vScope="parishes"
								:parishes="lists.parishes"
								:propPageID="pageID"
							/>
						</div>

						<div
							:id="`nav-${tabs[2]['code']}`"
							class="tab-pane fade"
							:class="{'show active': localActive==tabs[2]}"
							role="tabpanel"
							:aria-labelledby="`nav-${tabs[2]['code']}-tab`">
							<unity-users
								v-model="form.users"
								vScope="users"
								:propPageID="pageID"
							/>
						</div>
					</div>
					<buttons-footer
						:enableButtons="!readonlyFormItem"
						:cancelTitle="cancelTitle"
						:submitTitle="submitTitle"
						:isDisabled="isDisabled"
						@save="saveItem"
						@cancel="handleBack(`${moduleInternalCode}.${pageID}`)"/>
				</form>
			</div>
		</div>
	</layout-gestao>
</template>

<script>
	import mixin from '../../../../mixin';
	import UnityGeneral from './elements/UnityGeneral.vue';
	import UnityUsers from './elements/UnityUsers.vue';
	import UnityParishes from './elements/UnityParishes.vue';

	export default {
		components: {
			UnityParishes,
			UnityUsers,
			UnityGeneral
		},
		mixins: [mixin],
		provide () {
			return { parentValidator: this.$validator }
		},
		data() {
			return {
				pageID: 'parish_interventions_unities',
				user: null,
				form: {
					id: null,
					name: null,
                    email: null,
                    phone: null,
                    status: 1,
					users: [],
					parishes: [],
				},
				lists: {
					parishes: []
				},
				localActive: null
			}
		},
		mounted: function() {
			this.setInitTab();
			this.loadLists();
		},
		computed: {
			tabs: function() {
				return [
					{code: 'general', 'name': this.$t(`${this.pageID}.form.tabs.general`), active: true},
					{code: 'parishes', 'name': this.$t(`${this.pageID}.form.tabs.parishes`), active: true},
					{code: 'users', 'name': this.$t(`${this.pageID}.form.tabs.users`), active: true},
				];
			}
		},
		methods: {
			setInitTab: function(){
				this.localActive = this.tabs[0];
			},
			loadLists() {
				let url = this.url.getLists;
				if (!this.lists.loaded && url) {
					this.$http.get(url)
					.then(({data}) => {
						Object.keys(data).forEach(key => {
							if(key in this.lists) {
								this.lists[key] = data[key];
							}
						});
						this.lists.loaded = true;
					}).catch(error => {
						this.lists.loaded = false;
						this.showHttpError(error);
					});
				}
			},
			callbackLoadItem() {
				this.form.parishes = this.form.parishes.map((item) => { return item.parish});
			},
		}
	}
</script>